import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';

import { AddPatientPageStyled } from './AddPatientPageStyled';
import { EstadosBrasil } from '../../../main/constant/UfConstant';
import ContainerSideBarComponent from '../../component/container/ContainerSidebarComponent';

import { TfiSave } from 'react-icons/tfi';
import { FaArrowLeft } from 'react-icons/fa';
import { PiIdentificationCard } from 'react-icons/pi';
import { Button, Card, Col, Container, Form, Row } from 'react-bootstrap';
import { IoLocationOutline, IoPersonCircleOutline } from 'react-icons/io5';

import { EditPatient, InputsPatient, PropsAddPatient } from './AddPatientPageType';
import AlertComponent from '../../component/alert/AlertComponent';
import MessageConstant from '../../../main/constant/MessageConstant';
import { maskUtils } from '../../../main/helper/maskHelper';
import { FormatDate } from '../../../main/helper/dateFormatter';

/**
 * AddPatientPage
 * @param add
 * @param comeBack
 * @param patient
 * @param edit
 * @constructor
 */
const AddPatientPage: React.FC<PropsAddPatient> = ({ add, comeBack, patient, edit, getAddress, address }: PropsAddPatient) => {
  /** useForm */
  const {
    register,
    getValues,
    setValue,
    control,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm<InputsPatient>();

  /**
   * handleAdd
   */
  const handleAdd = async () => {
    const model = {
      id: 1,
      status: 'A',
      name: getValues('nome') ?? '',
      code: '',
      observation: getValues('observacoes') ?? '',
      birthDate: FormatDate.formatForValidation(getValues('dataNascimento')) ?? '',
      gender: getValues('sexo') ?? '',
      contact_CellPhone: getValues('celular') ?? '',
      contact_Phone: getValues('segundoTelefone') ?? '',
      contact_Email: getValues('email') ?? '',
      document_CPF: getValues('cpf') ?? '',
      document_RG: getValues('rg') ?? '',
      address_PostalCode: getValues('cep') ?? '',
      address_Street: getValues('endereco') ?? '',
      address_Number: getValues('numero') ?? '',
      address_Complement: getValues('complemento') ?? '',
      address_Neighborhood: getValues('bairro') ?? '',
      address_City: getValues('cidade') ?? '',
      address_State: getValues('uf') ?? '',
      responsible_Name: getValues('nomeResponsavel') ?? '',
      responsible_Document_CPF: getValues('cpfResponsavel') ?? '',
      responsible_Document_RG: getValues('rgResponsavel') ?? '',
      responsible_Contact_Phone: getValues('telefoneResponsavel') ?? '',
    };

    await add(model);
  };

  /**
   * handleEdit
   */
  const handleEdit = async () => {
    const model: EditPatient = {
      id: Number(getValues('id')),
      status: getValues('status') ?? 'A',
      name: getValues('nome') ?? '',
      code: getValues('codigo') ?? '',
      observation: getValues('observacoes') ?? '',
      birthDate: FormatDate.formatForValidation(getValues('dataNascimento')) ?? '',
      gender: getValues('sexo') ?? 'M',
      contact_CellPhone: getValues('celular') ?? '',
      contact_Phone: getValues('segundoTelefone') ?? '',
      contact_Email: getValues('email') ?? '',
      document_CPF: getValues('cpf') ?? '',
      document_RG: getValues('rg') ?? '',
      address_PostalCode: getValues('cep') ?? '',
      address_Street: getValues('endereco') ?? '',
      address_Number: getValues('numero') ?? '',
      address_Complement: getValues('complemento') ?? '',
      address_Neighborhood: getValues('bairro') ?? '',
      address_City: getValues('cidade') ?? '',
      address_State: getValues('uf') ?? '',
      responsible_Name: getValues('nomeResponsavel') ?? '',
      responsible_Document_CPF: getValues('cpfResponsavel') ?? '',
      responsible_Document_RG: getValues('rgResponsavel') ?? '',
      responsible_Contact_Phone: getValues('telefoneResponsavel') ?? '',
    };

    await edit(model);
  };

  /**
   * setModel
   * @param model
   */
  const setModel = (model: any) => {
    if (model !== null) {
      setValue('id', model.id);
      setValue('status', model.status);
      setValue('codigo', '');
      setValue('nome', model.name);
      setValue('email', model.contact_Email);
      setValue('celular', model.contact_CellPhone);
      setValue('segundoTelefone', model.contact_Phone);
      setValue('cpf', model.document_CPF);
      setValue('rg', model.document_RG);
      setValue('dataNascimento', FormatDate.formatToDateOnly(model.birthDate));
      setValue('sexo', model.sexo ?? 'M');
      setValue('observacoes', model.observation);
      setValue('cep', model.address_PostalCode);
      setValue('endereco', model.address_Street);
      setValue('numero', model.address_Number);
      setValue('complemento', model.address_Complement);
      setValue('bairro', model.address_Neighborhood);
      setValue('cidade', model.address_City);
      setValue('uf', model.address_State);
      setValue('nomeResponsavel', model.responsible_Name);
      setValue('cpfResponsavel', model.responsible_Document_CPF);
      setValue('rgResponsavel', model.responsible_Document_RG);
      setValue('telefoneResponsavel', model.responsible_Contact_Phone);
    }
  };

  /**
   * handleSubmitValidation
   */
  const handleSubmitValidation = async () => {
    patient === null ? await handleAdd() : await handleEdit();
  };

  /**
   * inicio
   */
  useEffect(() => {
    setModel(patient);
  }, [patient]);

  /**
   * handleCepChange - busca o endereco pelo cep
   * @param cep
   */
  const handleCepChange = async (cep: string) => {
    const cepFormatado = maskUtils.cep(cep);
    if (cepFormatado.length === 9) {
      await getAddress(cepFormatado);
    }
  };

  /**
   * inicio
   */
  useEffect(() => {
    if (address !== null) {
      setValue('endereco', address.street);
      setValue('bairro', address.neighborhood);
      setValue('cidade', address.city);
      setValue('uf', address.state);
    }
  }, [address]);

  const [mostraResponsavel, setMostraResponsavel] = useState<boolean>(false);
  const patientWatch = watch();

  useEffect(() => {
    if (patientWatch.dataNascimento) {
      const idade = calcularIdade(patientWatch.dataNascimento);
      // Lógica para mostrar ou não o responsável
      setMostraResponsavel(idade < 18); // Mostra responsável se a idade for menor que 18
    }
  }, [patientWatch.dataNascimento]);

  function calcularIdade(birthDate: string): number {
    const now = new Date();
    const date = new Date(birthDate);

    if (isNaN(date.getTime())) {
      throw new Error('A data fornecida não é válida.');
    }

    const yearsDiff = now.getFullYear() - date.getFullYear();
    return yearsDiff; // Retorna apenas a diferença de anos
  }

  return (
    <ContainerSideBarComponent>
      <AlertComponent />
      <AddPatientPageStyled>
        <Container fluid className="title-page text-center mb-4">
          <h3>{patient ? `Paciente - ${patient.name}` : 'Novo Paciente'}</h3>
        </Container>

        <Container fluid>
          <Card style={{ marginBottom: '40px' }}>
            <Card.Body>
              <Container fluid>
                <Form onSubmit={handleSubmit(handleSubmitValidation)}>
                  <input type="hidden" id="id" {...register('id')} />
                  <input type="hidden" id="status" {...register('status')} />
                  <input type="hidden" id="clinicId" {...register('clinicId')} />

                  <div className="container-field mb-4">
                    <Row className="row-field mb-3">
                      <Col className="d-flex justify-content-end">
                        <Button size="sm" type="submit" className="me-2">
                          <TfiSave /> Salvar
                        </Button>
                        <Button size="sm" variant="outline-primary" onClick={comeBack}>
                          <FaArrowLeft /> Voltar
                        </Button>
                      </Col>
                    </Row>
                    <div className="title">
                      <PiIdentificationCard />
                      <h6>Dados Pessoais</h6>
                    </div>

                    <Row className="row-field">
                      <Col sm={12} md={6} lg={4} className="mb-3">
                        <Form.Label>Nome</Form.Label>
                        <Form.Control placeholder="Nome" {...register('nome', { required: MessageConstant.validacao.campoObrigatorio })} />
                        {errors.nome && <span className="text-danger">{errors.nome.message}</span>}
                      </Col>
                    </Row>

                    <Row className="row-field">
                      <Col sm={12} md={6} lg={4} className="mb-3">
                        <Form.Label>Email</Form.Label>
                        <Form.Control placeholder="Email" {...register('email', { required: MessageConstant.validacao.campoObrigatorio })} />
                        {errors.email && <span className="text-danger">{errors.email.message}</span>}
                      </Col>
                      <Col sm={12} md={6} lg={4} className="mb-3">
                        <Form.Label>Celular</Form.Label>
                        <Controller
                          control={control}
                          name="celular"
                          rules={{ required: MessageConstant.validacao.campoObrigatorio }}
                          render={({ field }) => (
                            <Form.Control {...field} placeholder="Celular" onChange={(e) => field.onChange(maskUtils.celular(e.target.value))} />
                          )}
                        />
                        {errors.celular && <span className="text-danger">{errors.celular.message}</span>}
                      </Col>
                      <Col sm={12} md={6} lg={4} className="mb-3">
                        <Form.Label>Segundo telefone</Form.Label>
                        <Controller
                          control={control}
                          name="segundoTelefone"
                          render={({ field }) => (
                            <Form.Control {...field} placeholder="Segundo telefone" onChange={(e) => field.onChange(maskUtils.celular(e.target.value))} />
                          )}
                        />
                      </Col>
                    </Row>
                    <Row className="row-field">
                      <Col>
                        <Form.Label>CPF</Form.Label>
                        <Controller
                          control={control}
                          name="cpf"
                          render={({ field }) => <Form.Control {...field} placeholder="CPF" onChange={(e) => field.onChange(maskUtils.cpf(e.target.value))} />}
                        />
                        {errors.cpf && <span className="text-danger">{errors.cpf.message}</span>}
                      </Col>
                      <Col>
                        <Form.Label>RG</Form.Label>
                        <Controller
                          control={control}
                          name="rg"
                          render={({ field }) => <Form.Control {...field} placeholder="RG" onChange={(e) => field.onChange(maskUtils.rg(e.target.value))} />}
                        />
                        {errors.rg && <span className="text-danger">{errors.rg.message}</span>}
                      </Col>
                      <Col sm={2}>
                        <Form.Label>Data de nascimento</Form.Label>
                        <Form.Control
                          type="date"
                          placeholder="Data nascimento"
                          min="1900-01-01"
                          max="2100-12-31"
                          {...register('dataNascimento', { required: MessageConstant.validacao.campoObrigatorio })}
                        />
                        {errors.dataNascimento && <span className="text-danger">{errors.dataNascimento.message}</span>}
                      </Col>
                      <Col>
                        <Form.Label>Sexo</Form.Label>
                        <Controller
                          name="sexo"
                          control={control}
                          render={({ field }) => (
                            <Form.Select {...field}>
                              <option value="F">Feminino</option>
                              <option value="M">Masculino</option>
                            </Form.Select>
                          )}
                        />
                      </Col>
                    </Row>
                    <Row className="row-field">
                      <Col>
                        <Form.Label>Observações</Form.Label>
                        <Form.Control placeholder="Observações" {...register('observacoes')} />
                      </Col>
                    </Row>
                  </div>
                  <div className="container-field">
                    <div className="title">
                      <IoLocationOutline />
                      <h6>Endereço</h6>
                    </div>
                    <div>
                      <Row className="row-field">
                        <Col sm={3}>
                          <Form.Label>Cep</Form.Label>
                          <Controller
                            control={control}
                            name="cep"
                            render={({ field }) => (
                              <Form.Control
                                {...field}
                                placeholder="Cep"
                                onChange={(e) => {
                                  const cepComMascara = maskUtils.cep(e.target.value);
                                  field.onChange(cepComMascara);
                                  handleCepChange(cepComMascara);
                                }}
                              />
                            )}
                          />
                          {errors.cep && <span className="text-danger">{errors.cep.message}</span>}
                        </Col>
                        <Col>
                          <Form.Label>Endereço</Form.Label>
                          <Form.Control placeholder="Endereço" {...register('endereco')} />
                          {errors.endereco && <span className="text-danger">{errors.endereco.message}</span>}
                        </Col>
                      </Row>
                      <Row className="row-field">
                        <Col>
                          <Form.Label>Número</Form.Label>
                          <Form.Control placeholder="Número" {...register('numero')} />
                          {errors.numero && <span className="text-danger">{errors.numero.message}</span>}
                        </Col>
                        <Col>
                          <Form.Label>Complemento</Form.Label>
                          <Form.Control placeholder="Complemento" {...register('complemento')} />
                        </Col>
                        <Col>
                          <Form.Label>Bairro</Form.Label>
                          <Form.Control placeholder="Bairro" {...register('bairro')} />
                          {errors.bairro && <span className="text-danger">{errors.bairro.message}</span>}
                        </Col>
                        <Col>
                          <Form.Label>Cidade</Form.Label>
                          <Form.Control placeholder="Cidade" {...register('cidade')} />
                          {errors.cidade && <span className="text-danger">{errors.cidade.message}</span>}
                        </Col>
                        <Col>
                          <Form.Label>Estado</Form.Label>
                          <Form.Select aria-label="UF" {...register('uf')}>
                            <option value="">Selecione a UF</option>
                            {EstadosBrasil.map((item) => {
                              return (
                                <option key={item.sigla} value={item.sigla}>
                                  {item.nome}
                                </option>
                              );
                            })}
                          </Form.Select>
                          {errors.uf && <span className="text-danger">{errors.uf.message}</span>}
                        </Col>
                      </Row>
                    </div>
                  </div>
                  {mostraResponsavel === true && (
                    <div className="container-field">
                      <div className="title">
                        <IoPersonCircleOutline />
                        <h6>Responsável legal</h6>
                      </div>
                      <div>
                        <Row className="row-field">
                          <Col>
                            <Form.Label>Nome Responsável</Form.Label>
                            <Form.Control
                              placeholder="Nome Responsável"
                              {...register('nomeResponsavel', { required: MessageConstant.validacao.campoObrigatorio })}
                            />
                            {errors.nomeResponsavel && <span className="text-danger">{errors.nomeResponsavel.message}</span>}
                          </Col>
                        </Row>
                        <Row className="row-field">
                          <Col>
                            <Form.Label>CPF responsável</Form.Label>
                            <Controller
                              control={control}
                              name="cpfResponsavel"
                              rules={{ required: MessageConstant.validacao.campoObrigatorio }}
                              render={({ field }) => (
                                <Form.Control {...field} placeholder="CPF responsável" onChange={(e) => field.onChange(maskUtils.cpf(e.target.value))} />
                              )}
                            />
                            {errors.cpfResponsavel && <span className="text-danger">{errors.cpfResponsavel.message}</span>}
                          </Col>
                          <Col>
                            <Form.Label>RG responsável</Form.Label>
                            <Controller
                              control={control}
                              name="rgResponsavel"
                              render={({ field }) => (
                                <Form.Control {...field} placeholder="RG responsável" onChange={(e) => field.onChange(maskUtils.rg(e.target.value))} />
                              )}
                            />
                          </Col>
                          <Col>
                            <Form.Label>Telefone responsável</Form.Label>
                            <Controller
                              control={control}
                              name="telefoneResponsavel"
                              rules={{ required: MessageConstant.validacao.campoObrigatorio }}
                              render={({ field }) => (
                                <Form.Control
                                  {...field}
                                  placeholder="Telefone responsável"
                                  onChange={(e) => field.onChange(maskUtils.celular(e.target.value))}
                                />
                              )}
                            />
                            {errors.telefoneResponsavel && <span className="text-danger">{errors.telefoneResponsavel.message}</span>}
                          </Col>
                        </Row>
                      </div>
                    </div>
                  )}
                </Form>
              </Container>
            </Card.Body>
          </Card>
        </Container>
      </AddPatientPageStyled>
    </ContainerSideBarComponent>
  );
};

export default AddPatientPage;
